<template>
<div>

      <div class="modal-backdrop" v-if="notifications.length" :class="{show: notifications.length}">
        <transition name="fade" appear>
      <div class="notification-modal" v-if="notifications.length"  :class="{show: notifications.length}"> 
        <NotificationBar
          v-for="notification in notifications"
          :key="notification.id"
          :notification="notification"

        />
       </div>
           </transition>
    </div>

    </div>
</template>

<script>
import NotificationBar from '@/components/notifications/NotificationBar.vue'
import { mapState } from 'vuex'
export default {
  components: { NotificationBar },
  computed: mapState('notification', ['notifications'])
}
</script>

<style scoped>
.notification-modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  display: none;
}

.notification-modal.show {
  display: block;
  transition: opacity 0.15s linear;
}

.modal-backdrop.show {
  z-index: 1190 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
